import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Textfield } from '@digdir/designsystemet-react';

interface CalculatedValueProps {
  parameterKey: string;
  calculatedValue: number;
}

export const CalculatedValue: FC<CalculatedValueProps> = ({ parameterKey, calculatedValue }) => {
  const { t } = useTranslation();

  const calculatedLabel = `${t(`register.parameters.type.${parameterKey}`)}-${t('register.parameters.calculated')}`;

  return <Textfield aria-label={calculatedLabel} value={Number(calculatedValue.toFixed(3))} readOnly />;
};
